import { Component } from '@angular/core';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
    selector: 'app-na',
    template: '<span class="unimportant-text">N / A</span>'
})
export class NAComponent {}
